var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRates1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 339,
    viewBox: "0 0 339 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5656_6105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1823 0.323265H218.148C220.407 0.969903 222.504 1.7782 224.44 3.07148C240.253 14.3876 255.259 33.7868 270.91 45.7496C271.716 46.3962 272.523 47.2045 273.653 47.5278L321.09 1.45488C332.869 -4.68818 344.486 9.3762 336.418 19.7224L19.8463 336.252C8.39034 344.82 -5.32456 331.24 2.09762 320.086C5.32465 315.074 15.8125 308.446 18.3941 303.758C19.8463 301.333 19.2009 283.712 19.2009 279.509C17.7487 199.003 18.5555 118.173 18.5555 37.6666C20.6531 18.2675 35.6588 2.74816 55.1823 0.323265ZM204.433 24.2489H56.4732C51.9553 24.2489 42.4356 33.7868 42.4356 38.3133V279.186L221.052 101.037V99.9055C215.082 96.5107 209.273 88.4277 206.853 81.9613C206.369 80.8297 204.433 74.3633 204.433 73.8784V24.2489ZM228.635 40.2532V70.8068C228.635 74.04 235.735 83.4163 239.446 82.4463L256.549 65.4721L228.635 40.0915V40.2532Z",
    fill: "#E0EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2851 335.605C65.1857 328.977 69.3808 315.721 79.2233 314.751H279.622C289.303 313.943 295.757 307.476 296.564 297.615V95.0557C299.63 80.5064 319.476 81.3147 320.767 96.5107V300.04C318.992 320.894 302.695 337.222 281.881 339H80.6754C77.9325 339 74.2214 337.545 72.2851 335.605Z",
    fill: "#E0EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.031 224.222C167.483 222.767 171.033 221.15 172.969 220.989C192.331 222.929 216.211 218.564 234.928 220.989C248.32 222.767 248.804 243.136 234.121 245.076C215.727 247.662 192.009 243.459 172.969 245.076C163.127 243.783 159.093 231.173 166.031 224.222Z",
    fill: "#E0EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.395 94.0859H171.356C185.393 96.5108 184.909 116.233 171.356 118.012C151.187 120.76 125.048 116.072 104.233 118.012C90.3571 115.263 90.8411 96.8341 104.233 94.0859H104.395Z",
    fill: "#E0EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.588 157.618C109.074 156.648 126.984 156.81 132.954 157.456C148.282 158.911 147.798 179.765 134.406 181.544C129.727 182.19 105.524 182.19 101.974 180.897C90.841 177.017 92.2932 159.72 103.749 157.618H103.588Z",
    fill: "#E0EBF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5656_6105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 339,
    height: 339,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRates1);
export default __webpack_public_path__ + "static/media/no-rates1.848587aa839f21808c91509e5824ec37.svg";
export { ForwardRef as ReactComponent };